import React from 'react'

const StatusIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.668 20C9.28464 20 7.98464 19.7373 6.76797 19.212C5.5513 18.6873 4.49297 17.975 3.59297 17.075C2.69297 16.175 1.98064 15.1167 1.45597 13.9C0.930636 12.6833 0.667969 11.3833 0.667969 10C0.667969 8.61667 0.930636 7.31667 1.45597 6.1C1.98064 4.88333 2.69297 3.825 3.59297 2.925C4.49297 2.025 5.5513 1.31233 6.76797 0.787C7.98464 0.262333 9.28464 0 10.668 0C12.0513 0 13.3513 0.262333 14.568 0.787C15.7846 1.31233 16.843 2.025 17.743 2.925C18.643 3.825 19.3553 4.88333 19.88 6.1C20.4053 7.31667 20.668 8.61667 20.668 10C20.668 11.3833 20.4053 12.6833 19.88 13.9C19.3553 15.1167 18.643 16.175 17.743 17.075C16.843 17.975 15.7846 18.6873 14.568 19.212C13.3513 19.7373 12.0513 20 10.668 20ZM10.668 13C11.5013 13 12.2096 12.7083 12.793 12.125C13.3763 11.5417 13.668 10.8333 13.668 10C13.668 9.16667 13.3763 8.45833 12.793 7.875C12.2096 7.29167 11.5013 7 10.668 7C9.83464 7 9.1263 7.29167 8.54297 7.875C7.95964 8.45833 7.66797 9.16667 7.66797 10C7.66797 10.8333 7.95964 11.5417 8.54297 12.125C9.1263 12.7083 9.83464 13 10.668 13Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default StatusIcon
